import { esc } from '@/utils/escape';

export function generateHeroHTML(data: any, settings: any): string {
  return `  <!-- Hero -->
  <section class="hero"> <!-- QA: B-1 — id="main" moved to <main> wrapper -->
    <div class="container">
      <div class="hero__inner">
        <div class="hero__content">
          <h1 class="hero__title">${esc(data.title)}</h1>
          <p class="hero__text">${esc(data.subtitle)}</p>
          <div class="hero__actions">
            <a href="#kontakt" class="btn btn--primary">${esc(data.primaryBtn)}</a>
            <a href="#leistungen" class="btn btn--secondary">${esc(data.secondaryBtn)}</a>
          </div>
        </div>
        ${
          data.imageUrl
            ? `
        <div class="hero__image">
          <img src="${esc(data.imageUrl)}" alt="Hero" loading="lazy">
        </div>`
            : ""
        }
      </div>
    </div>
  </section>`;
}
